export default __webpack_public_path__ + "static/media/hustler.53a82ba9.gif";